import React, {} from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { MdKeyboardArrowLeft as Ico } from 'react-icons/md';
// Components
import CommonButton from "../../common/button/button";
// Actions
import * as mainActions from "../../../redux/actions/main";

const ButtonBack = ({ config }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Selectors
  const currentPage = useSelector(state => state.mainReducer.currentPage);
  const breadscrum = useSelector(state => !!state.mainReducer.breadscrum[currentPage] ? state.mainReducer.breadscrum[currentPage] : []);

  let caption = "Enrere"
  let onClick = () => { 
    let goTo = currentPage;
    // Remove current item of breadscrum
    let updatedBreadscrum = breadscrum;
    if (breadscrum.length > 0) {
      updatedBreadscrum = breadscrum.slice(0, -1);
      dispatch(mainActions.setBreadscrum(currentPage, updatedBreadscrum));
    }
    if (updatedBreadscrum.length > 0) {
      const item = updatedBreadscrum[updatedBreadscrum.length - 1];
      goTo = item.path;
    }
    // Goto
    navigate(`/${goTo}`);
  };
  let width = "120px";
  let marginLeft = "0px";
  if (!!config) {
    if (config.visible === false) return null;
    caption = config.caption || caption;
    width = config.width || width;
    marginLeft = config.marginLeft || marginLeft;
  }
  return (
    <CommonButton 
      onClick={onClick} 
      style={{
        width,
        marginLeft,
        display: "flex", // Use flexbox to control alignment
        alignItems: "center", // Center icon and text vertically
        justifyContent: "flex-start", // Align icon and text to the left
        gap: "8px", // Add spacing between icon and text
      }}
      inverted={true}
    >
      <Ico size={18} />
      <span>{caption}</span>
    </CommonButton>
  );
};

export default ButtonBack;
